// r24 — /en/translate/naati/city/$slug
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiThProvinceRenderer from "@/components/NaatiThProvinceRenderer";
import { getNaatiProvince } from "@/data/naati-th-provinces";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";

export const Route = createFileRoute("/en/translate/naati/city/$slug")({
  loader: ({ params }) => {
    const p = getNaatiProvince(params.slug);
    if (!p) throw notFound();
    return { province: p };
  },
  head: ({ params }) => {
    const p = getNaatiProvince(params.slug);
    if (!p) return { meta: [{ title: ctaTitle("Not found", "/en/translate/naati/city/$slug", "en")}, { name: "robots", content: "noindex" }] };
    const url = `${SITE}/en/translate/naati/city/${p.slug}`;
    const title = `NAATI Translation in ${p.en}, Thailand — 3-day turnaround | NYC`;
    const desc = `NAATI Certified translation service for clients in ${p.en} (${p.regionEn}) — DHL Domestic 1–2 business days, all Australian visa types. Talk to a specialist today.`;
    return {
      meta: [
        { title: ctaTitle(title, "/en/translate/naati/city/$slug", "en") }, { name: "description", content: ctaDesc(desc, "/en/translate/naati/city/$slug", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/translate/naati/city/$slug", "en")}, { property: "og:description", content: ctaDesc(desc, "/en/translate/naati/city/$slug", "en")},
        { property: "og:url", content: url }, { property: "og:locale", content: "en_US" },
      ],
      links: canonicalAndHreflang(`/translate/naati/city/${p.slug}`, `/en/translate/naati/city/${p.slug}`),
      scripts: [
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "Service", inLanguage: "en",
          name: `NAATI Translation in ${p.en}`,
          areaServed: { "@type": "AdministrativeArea", name: p.en, address: { "@type": "PostalAddress", addressRegion: p.regionEn, addressCountry: "TH" } },
          provider: { "@type": "Organization", name: "NYC Language Institute", url: SITE }, url,
        }) },
      ],
    };
  },
  component: () => {
    const { province } = Route.useLoaderData();
    return <NaatiThProvinceRenderer locale="en" province={province} />;
  },
});
